import { createSelector, createSlice } from '@reduxjs/toolkit';
import platformDevices from '../../public/devices.json';

const initialState = {
  devices: [],
  selectedDevice: null
};

const platformDeviceSlice = createSlice({
  name: 'platformDevice',
  initialState,
  reducers: {
    loadPlatformDevice(state, action) {
      state.devices = platformDevices;
    },
    selectPlatformDevice(state, action) {
      const deviceName = action.payload;
      state.selectedDevice = state.devices.find(device => device.name === deviceName);
    },
    deSelectPlatformDevice(state, action) {
      state.selectedDevice = null;
    }
  },
});


export const selectDeviceBySize = createSelector(
  state => state.device.devices,
  (_, width, height) => ({ width, height }),
  (devices, { width, height }) => {
    const device = devices.find(device => device.width === width && device.height === height);
    return device ? device : null;
  }
);

export const selectDeviceByName = createSelector(
  state => state.device.devices,
  (_, deviceName) => deviceName,
  (devices, deviceName) => devices.find(device => device.name === deviceName)
);

export const { loadPlatformDevice, selectPlatformDevice, deSelectPlatformDevice } = platformDeviceSlice.actions;
export default platformDeviceSlice.reducer;
